import { get, isEmpty } from 'lodash';
import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, Switch, useHistory } from 'react-router-dom';
import UpdatePassword from '../components/global/UpdatePassword';
import UserHeader from '../components/global/UserHeader';
import AppLoader from '../components/loaders/AppLoader';
import Dashboard from '../containers/TruckInspector/Dashboard';
// import MessageList from '../containers/TruckInspector/Messages/MessageList';
import EditProfile from '../containers/TruckInspector/Profile/EditProfile';
import ViewProfile from '../containers/TruckInspector/Profile/ViewProfile';
import { ValidateRoutes } from './ClientRoute';
import Notification from '../components/global/Notification';
import NotificationMenuItem from '../components/global/NotificationBadge';
import { NT_TI_DASHBOARD } from '../helpers/constants';
import { hideDocumentModal } from '../redux/user/UserActions';
import DocumentModal from '../components/Modals/DocumentModal';
import { readNotification } from '../redux/notification/NotificationActions';

const TruckInspectorRouting = (props) => {
  let history = useHistory();
  const dispatch = useDispatch();
  const userStoreState = useSelector((state) => state.user);
  const { user } = userStoreState;

  const [siderMemuToggle, setSiderMemuToggle] = useState(false);

  const { match } = props;
  const { pathname } = props.location;

  if (isEmpty(user)) {
    return <AppLoader />;
  }

  const onMenuClick = (path, notificationTypes) => {
    history.push(path);
    setSiderMemuToggle(false);

    // mark the notifications of the menu as read
    if (notificationTypes) {
      dispatch(readNotification({ notificationTypes }));
    }
  };

  return (
    <div id="truck-inspector-page">
      <Helmet>
        <title>GoAgent</title>
      </Helmet>
      <UserHeader />
      <main id="main" className="main-block">
        <div className="bodycont">
          <div style={{ clear: 'both' }}></div>

          <div className="tab">
            <div className="cormen-btn">
              <label htmlFor="cormid"></label>
            </div>
            <div className="cormen">
              <input
                id="cormid"
                type="checkbox"
                checked={siderMemuToggle}
                onChange={(e) => setSiderMemuToggle(e.target.checked)}
              />
              <ul>
                <button
                  className={`tablinks ${
                    pathname.includes('/truck-inspector/dashboard') ? 'active' : ''
                  }`}
                  onClick={() => onMenuClick('/truck-inspector/dashboard', NT_TI_DASHBOARD)}
                >
                  <NotificationMenuItem title="Dashboard" types={NT_TI_DASHBOARD} />
                </button>{' '}
                <button
                  className={`tablinks ${
                    pathname.includes('/truck-inspector/profile') ||
                    pathname.includes('/truck-inspector/edit-profile')
                      ? 'active'
                      : ''
                  }`}
                  onClick={() => onMenuClick('/truck-inspector/profile')}
                >
                  My Profile
                </button>
                {/* <button className={`tablinks ${pathname.includes('/messages') ? 'active' : ''}`} onClick={() => onMenuClick('/truck-inspector/messages')}>
                  My Message
                </button> */}
                <button
                  className={`tablinks ${pathname.includes('/notifications') ? 'active' : ''}`}
                  onClick={() => onMenuClick('/truck-inspector/notifications')}
                >
                  My Notification
                </button>
              </ul>
            </div>
          </div>

          <Switch>
            <ValidateRoutes
              exact
              path={`${match.url}/dashboard`}
              component={Dashboard}
              has_permission={get(user, 'type') === 'truck_inspector'}
            />
            <ValidateRoutes
              exact
              path={`${match.url}/profile`}
              component={ViewProfile}
              has_permission={get(user, 'type') === 'truck_inspector'}
            />
            <ValidateRoutes
              exact
              path={`${match.url}/profile/update-password`}
              component={UpdatePassword}
              has_permission={get(user, 'type') === 'truck_inspector'}
            />

            <ValidateRoutes
              exact
              path={`${match.url}/edit-profile`}
              component={EditProfile}
              has_permission={get(user, 'type') === 'truck_inspector'}
            />
            {/* <ValidateRoutes exact path={`${match.url}/messages`} component={MessageList} has_permission={get(user, 'type') === 'truck_inspector'} /> */}
            <ValidateRoutes
              exact
              path={`${match.url}/notifications`}
              component={Notification}
              has_permission={get(user, 'type') === 'truck_inspector'}
            />

            <Redirect from={match.url} to={`${match.url}/dashboard`} />
          </Switch>
          <div className="clearfix"></div>
        </div>
        {/* Modal to Display Document */}
        {userStoreState?.displayDocumentModal && (
          <DocumentModal
            isOpen={userStoreState.displayDocumentModal}
            toggle={() => dispatch(hideDocumentModal())}
            documentToShow={userStoreState.documentToDisplay}
            container="truck-inspector-page"
          />
        )}
      </main>
    </div>
  );
};

export default TruckInspectorRouting;
